
export const MAX_DISTANCE_WALKING_LABELS: { value: number; label: string }[] = [
  { label: '200m', value: 200 },
  { label: '500m', value: 500 },
  { label: '1km', value: 1000 },
  { label: '2km', value: 2000 },
  { label: '3km', value: 3000 },
];